import React, { useState, useContext, useEffect, useRef } from "react";
import "./MainContent.css";
import CytoscapeGraph from "./CytoscapeComponent";
import TopicGraph from "./TopicGraph";
import { Spinner } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { SiMinutemailer } from "react-icons/si";
import { LuSave } from "react-icons/lu";
import useSavedSearches from "../../hooks/useSavedSearches";
import useGroups from "../../hooks/useGroups";
import useGraphData from "../../hooks/useGraphData";
import ModalComponent from "../common/ModalComponent";
import useTopicGraph from "../../hooks/useTopicGraph";
import { ViewContext } from "../../context/ViewContext";
import groupService from "../../services/groupService";
import NodeSchemaViewPane from "./NodeSchemaPane";
import CreateGroupModal from "../common/CreateGroupModal";
import CreateChildModal from "../common/CreateChildModal";
import axios from "axios";
import SchemaInfo from "../common/SchemaInfo";
import CreateNode from "../common/CreateNode";
import ExportModal from "../common/ExportModal";
import { IoResize } from "react-icons/io5";
import { FiPlus, FiMinus } from "react-icons/fi";
import DeleteGroupModal from "../common/DeleteGroupModal";
import TagsInputSearch from "../common/TagInputSearch";
import SaveSearchModal from "../common/SaveSearchModal";
import SearchComponent from "../common/SearchComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  clearGraphData,
  handleCreateModelThunk,
  handleSearchSelectThunk,
  handleTagChangeThunk,
  updateEdgeCount,
  setIncludeKeywords,
  addToFilter,
  setSelectedLeafClasses,
  fetchAllChildGraphData,
  setFilterNodeAndCopyLink,
  setSearchId,
  fetchGraphDataThunk,
  setIsCopyLink,
  setIncludeIds,
  handleAttachmentGroupThunk,
} from "../../redux/slices/graphSlice";

import api from "../../api/apiClient";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useUserId } from "../../Utils/helpers";
import { loginThunk } from "../../redux/slices/authSlice";
import Select from "react-select";
import Loader from "../common/Spinner";

const MainContent = () => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const currentRole = useSelector((state) => state.auth.currentRole);
  const location = useLocation();
  const hashString = location.hash;

  const searchParams = new URLSearchParams(hashString.slice(1));
  const navigate = useNavigate();
  const userId = useUserId();

  const zoomInInterval = useRef(null);
  const zoomOutInterval = useRef(null);

  const { viewType } = useContext(ViewContext);
  const dispatch = useDispatch();
  const { graphData, loading, error } = useSelector((state) => state.graph);
  const { filters } = useSelector((state) => state.graph);

  const {
    savedSearches,
    loading: savedSearchesLoading,
    error: savedSearchesError,
    refetch: savedSearchRefetch,
  } = useSavedSearches(userId);
  const {
    groups,
    loading: groupsLoading,
    error: groupsError,
    refetch,
  } = useGroups();
  const {
    graphSchemaData,
    loading: graphLoading,
    refetch: refetchGraphData,
  } = useGraphData();
  const { topicGraphData, loading: topicGraphLoading } = useTopicGraph(userId);

  // const [graphData, setGraphData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
  const [showCreateChildModal, setShowCreateChildModal] = useState(false);
  const [selectedParentNode, setSelectedParentNode] = useState(null);

  const [showNodeModal, setShowNodeModal] = useState(false);
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [schemaGraphData, setSchemaGraphData] = useState([]);

  const [nodes, setNodes] = useState([]);
  const [startNode, setStartNode] = useState("");
  const [nameRequired, setNameRequired] = useState(false);
  const [classOptions, setClassOptions] = useState([]);
  const [secondDropdownOptions, setSecondDropdownOptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedRelation, setSelectedRelation] = useState("");
  const [selectedNodeData, setSelectedNodeData] = useState(null);
  const [selectedSchemaData, setSelectedSchemaData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedSearchId, setSelectedSearchId] = useState(null);
  const [deleteType, setDeleteType] = useState("");

  const [tags, setTags] = useState([]);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [isEditGroupMode, setIsEditGroupMode] = useState(false);
  const [showSaveSearchModal, setShowSaveSearchModal] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [searchName, setSearchName] = useState("");
  const [isPlaybookLink, setIsPlaybookLink] = useState(false);
  const [groupLoading, setGroupLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [modelLoading, setModelLoading] = useState(false);
  const [saveSearchLoading, setSaveSearchLoading] = useState(false);

  const handleCloseSearchModal = () => setShowSearchModal(false);

  const [cyRef, setCyRef] = useState(null);

  // Retrieve the parameters
  const hash = window.location.hash;
  const hashSegments = window.location.hash.split("/");
  const filterIncludeManual = searchParams.get("filter_includeManual");
  const select = searchParams.get("select");
  const version = searchParams.get("v");
  const isPlaybookRoute =
    hash.includes("#filter_includeManual=") &&
    !hash.includes("from=doctracker");

  const isSpecificFilterRoute = hashSegments.length === 3;
  const hideSidebar = isSpecificFilterRoute && isPlaybookRoute;

  useEffect(() => {
    if (select != null) {
      if (isSpecificFilterRoute) {
        const username = hashSegments[2];
        const authToken = hashSegments[1];
        dispatch(loginThunk({ username, token: authToken })).unwrap();
      }
      // First, save the filter node and copy link status
      dispatch(
        setFilterNodeAndCopyLink({
          filterNode: filterIncludeManual,
          isCopyLink: true, // Set this based on your requirements
          version: version,
        })
      );
      dispatch(
        fetchAllChildGraphData({
          userId: userId,
          nodeId: select,
        })
      ).unwrap();
      navigate("/");
    }
  }, [filterIncludeManual, select]);

  useEffect(() => {
    if (hideSidebar) {
      setIsPlaybookLink(hideSidebar);
    }
  }, [filterIncludeManual, select, version, hideSidebar]);

  useEffect(() => {
    if (cyRef) {
      dispatch(updateEdgeCount(cyRef.edges().length));
    }
  }, [cyRef, dispatch]);

  const handleCyRef = (cy) => {
    if (cy) {
      setCyRef(cy);
    }
  };

  const handleSaveSearch = async (data) => {
    let rulesForJson = {
      includeClasses: [],
      includeTopics: [],
      includeKeywords: Array.from(filters.includeKeywords),
    };

    setSaveSearchLoading(true); // Start loader

    if (isEditMode) {
      try {
        const { searchName, comment, link } = data;

        await groupService.updateSavedSearch(
          selectedSearchId,
          searchName,
          comment,
          link
        );
        closeCreateGroupModal();
        savedSearchRefetch();
        toast.success("Search updated successfully");
      } catch (error) {
        toast.error(error.message || "Error updating search");
        console.error("Error updating search:", error);
      }
    } else {
      try {
        const { searchName, comment, link } = data;
        await groupService.saveSearch(
          userId,
          searchName,
          comment,
          link,
          rulesForJson
        );
        closeCreateGroupModal();
        setIsSaved(!isSaved);
        savedSearchRefetch();
        toast.success("Search saved successfully");
      } catch (error) {
        toast.error(error.message || "Error saving search");
        console.error("Error saving search:", error);
      }
    }

    setSaveSearchLoading(false); // Stop loader
    setShowSearchModal(false);
  };

  const handleOpenEditModal = () => {
    if (selectedSearchId) {
      setIsEditMode(true);
      setShowSearchModal(true);
    }
  };

  const handleAddKeyword = (newClasses) => {
    dispatch(
      addToFilter({
        filterType: "includeKeywords",
        values: newClasses,
      })
    );
    // dispatch(fetchFilteredGraphData({ userId: 1 }));
  };

  const handleEditGroup = () => {
    fetchSchemaGraph();
    setIsEditGroupMode(true);
    setShowCreateGroupModal(true);
  };

  const handleChange = async (newTags) => {
    dispatch(setIsCopyLink(false));
    dispatch(setIncludeKeywords(newTags));
    dispatch(setSelectedLeafClasses());
    handleAddKeyword(newTags);
    if (newTags?.length > 0) {
      try {
        await dispatch(handleTagChangeThunk({ userId, newTags })).unwrap();
      } catch (error) {
        console.error("Error calling API:", error);
      }
    } else {
      if (filters.includeClasses && filters.includeClasses.size > 0) {
        dispatch(setIncludeKeywords());
        // Ensure filters.includeClasses is a Set
        if (filters.includeClasses instanceof Set) {
          const includeClasses = Array.from(filters.includeClasses);

          if (Array.isArray(includeClasses) && includeClasses.length > 0) {
            await dispatch(
              fetchGraphDataThunk({ userId, selectedClasses: includeClasses })
            ).unwrap();
          }
        }
      } else {
        dispatch(clearGraphData());
      }
    }
  };

  const fetchSchemaGraph = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_API_ENDPOINT}/schema/graph`
      );
      const { nodes } = response.data;
      setSchemaGraphData(nodes);
      const filteredNodes = nodes.filter((node) => node.class_kind === "node");
      const classes = filteredNodes.map((node) => node.class);
      setClassOptions(classes);
    } catch (err) {
      console.error("Failed to fetch schema graph data", err);
    }
  };

  const fetchSecondDropdownOptions = async (className) => {
    if (className) {
      try {
        const response = await axios.post(
          `${REACT_APP_API_ENDPOINT}/name/range-domain`,
          {
            class_name: className,
          }
        );

        // Store raw data and format the options for display
        const formattedOptions = response.data.map((item) => ({
          display: `${item.relation}: ${item.src_classname} --> ${item.dst_classname}`,
          raw: item,
        }));

        setSecondDropdownOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching data for second dropdown:", error);
      }
    }
  };

  const handleClassChange = (className) => {
    setSelectedClass(className);
    fetchSecondDropdownOptions(className);
  };

  const handleRelationChange = (className) => {
    setSelectedRelation(className);
    // fetchSecondDropdownOptions(className);
  };

  const handleDropdownChange = async (selectedOption) => {
    const selectedGroupId = selectedOption?.value;

    if (!selectedGroupId) {
      setSelectedGroupId(null);
    } else {
      setSelectedGroupId(selectedGroupId);
    }

    const selectedGroup = groups.find(
      (group) => group.id === parseInt(selectedGroupId, 10)
    );

    if (selectedGroup) {
      setSelectedGroupName(selectedGroup.name);
      setShowPopup(true);
      setShowDeletePopup(false);
      setShowExportPopup(false);

      try {
        const data = await groupService.fetchGroupData(selectedGroup.name);

        const relations = data.relations_string
          .split(",\n")
          .filter((item) => item.trim() !== "");
        setNodes(relations);
        setStartNode(data.start_node);
        setNameRequired(data.name_required);
      } catch (error) {
        console.error("Error fetching group data:", error.message);
      }
    }
  };

  const handleDeleteClick = () => {
    if (selectedGroupName) {
      setDeleteType("group");
      setShowDeletePopup(true); // Show delete popup when a group is selected
    }
  };

  const handleDeleteGroup = async () => {
    try {
      await groupService.deleteGroup(selectedGroupName);
      toast.success(`Successfully deleted group: ${selectedGroupName}`);
      await refetch();
      setSelectedGroupName("");
      setSelectedGroupId(null);
    } catch (error) {
      console.error("Error deleting group:", error.message);
      toast.error(`Failed to delete group`);
    } finally {
      setShowDeletePopup(false);
    }
  };

  const handleDeleteSearchClick = () => {
    if (!selectedSearchId) {
      toast.error("Please select a saved search to delete.");
      return;
    }
    setShowDeletePopup(true);
    setDeleteType("customSearch");
  };

  const handleDeleteCustomSearch = async () => {
    try {
      await groupService.deleteCustomSearch(selectedSearchId);
      window.location.reload();
      toast.success(`Successfully deleted custom search`);
    } catch (error) {
      console.error("Error deleting custom search:", error.message);
      toast.error(`Failed to delete custom search`);
    } finally {
      setShowDeletePopup(false);
    }
  };

  const handleSearchSelect = async (selectedOption) => {
    const searchId = selectedOption?.value; // Retrieve the value
    setSelectedSearchId(searchId);
    dispatch(setSearchId(searchId));
    try {
      await dispatch(handleSearchSelectThunk({ searchId, userId })).unwrap();
    } catch (err) {
      console.error("Error in handleSearchSelect:", err);
    }
  };

  const handleCreateGroup = (node) => {
    fetchSchemaGraph();
    setIsEditGroupMode(false);
    setShowCreateGroupModal(true);
  };

  const handleCreateChild = (node) => {
    setSelectedParentNode(node);
    setShowCreateChildModal(true);
  };

  const closeCreateChildModal = () => {
    setShowCreateChildModal(false);
    setSelectedParentNode(null);
  };

  const createChildNode = async (childName, childDescription) => {
    if (!selectedParentNode) return;

    const payload = {
      _oid: selectedParentNode.props._oid,
      name: childName,
      supercls: selectedParentNode.name,
      colour: selectedParentNode.colour,
      desc: childDescription,
      fields: selectedParentNode.props.fields,
    };

    try {
      await api.post("/schema/graph", payload);
      toast.success("Child created successfully");
      refetchGraphData();
      closeCreateChildModal();
    } catch (error) {
      console.error("Error creating child node:", error);
      toast.error("Error creating child node");
    }
  };

  const handleNodeClick = (nodeData) => {
    setSelectedNodeData({ nodeData, cy: cyRef });
    setShowNodeModal(true);
  };

  const handleSchemaClick = (schemaData) => {
    setSelectedSchemaData(schemaData);
    setIsModalOpen(true);
  };

  const closeCreateGroupModal = () => {
    setShowCreateGroupModal(false);
  };

  const closeNodeModal = () => {
    setShowNodeModal(false);
  };

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  function extractFirstValue(array) {
    if (!array || !Array.isArray(array) || array.length === 0) {
      return "";
    }

    const firstElement = array[0];
    if (!firstElement || typeof firstElement !== "string") {
      return "";
    }

    const parenthesisIndex = firstElement.indexOf("(");
    const closingParenthesisIndex = firstElement.indexOf(")");

    // If parentheses are found, include everything up to and including the closing parenthesis
    if (parenthesisIndex !== -1 && closingParenthesisIndex !== -1) {
      return firstElement.substring(0, closingParenthesisIndex + 1);
    }

    // If no parentheses, return the element as it is
    return firstElement;
  }

  const handleCreateModel = async () => {
    const fetchNode = extractFirstValue(nodes);

    // Set loading to true when the operation begins
    setModelLoading(true);

    try {
      await dispatch(
        handleCreateModelThunk({
          userId,
          nodes,
          startNode,
          nameRequired,
          fetchNode,
        })
      ).unwrap();

      handlePopupClose();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      // Set loading to false when the operation finishes (success or error)
      setModelLoading(false);
    }
  };

  const validateInputs = (groupData) => {
    const newErrors = {};

    // Validate group name
    if (!groupData.name || !groupData.name.trim()) {
      newErrors.groupName = "Group name cannot be empty.";
    }

    // Set errors and return validation result
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleGroupSave = async (groupData, attachedFilesToNode) => {
    if (!validateInputs(groupData)) {
      return;
    }

    setGroupLoading(true); // Start loading
    try {
      if (groupData.attached_files.length === 0) {
        const response = await api.post("/group/save", groupData, {
          headers: {
            "X-Api-Key": "6XxnCdOnCfwHEKwM",
          },
        });

        if (response.status !== 200) {
          throw new Error("Failed to save the group");
        }

        setSelectedGroupId(null);
        setSelectedClass("");
        toast.success("Group saved successfully:");
        closeCreateGroupModal();
        refetch();
      } else {
        const relationsString = groupData.relations_string || "";
        const dropdownArray = relationsString.split(","); // Split relations_string like in old code

        const fileAttachment = Object.entries(
          attachedFilesToNode || {}
        ).flatMap(([node, fileName]) =>
          fileName ? `${node}^${fileName}` : []
        );

        const nodeData = {
          nodes: dropdownArray,
          file_attachment: fileAttachment,
        };

        const response = await api.post("/create/attachment-group", nodeData, {
          headers: {
            "X-Api-Key": "6XxnCdOnCfwHEKwM",
          },
        });

        if (response.status !== 200 || response.data.status !== "success") {
          throw new Error("Failed to create attachment group");
        }

        const createdNodes = response.data.createdNodes;
        const createdNodeKeys = Object.keys(createdNodes);
        const fetchNode = extractFirstValue(dropdownArray);

        const includeIds = createdNodeKeys
          .filter(
            (nodeKey) => nodeKey === fetchNode // Match fetchNode with created nodes
          )
          .map((nodeKey) => createdNodes[nodeKey]?.id);

        dispatch(setIncludeIds(includeIds));
        await dispatch(handleAttachmentGroupThunk({ userId })).unwrap();

        setSelectedGroupId(null);
        toast.success("Group created successfully:");
        setSelectedClass("");
        closeCreateGroupModal();
        refetch();
      }
    } catch (error) {
      console.error("Error saving group:", error);
      toast.error("Error saving group.");
    } finally {
      setGroupLoading(false); // Stop loading
    }
  };

  const handleGroupEdit = async (groupData) => {
    if (!validateInputs(groupData)) {
      return;
    }
    setGroupLoading(true); // Start loading
    const grpData = {
      name: groupData.name,
      id: selectedGroupId,
      relations_string: groupData.relations_string,
      description: groupData.description,
      start_node: groupData.start_node,
      related_nodes: null,
    };
    try {
      const response = await fetch(`${REACT_APP_API_ENDPOINT}/group/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": "6XxnCdOnCfwHEKwM",
        },
        body: JSON.stringify(grpData),
      });

      if (!response.ok) {
        throw new Error("Failed to update the group");
      }

      const data = await response.json();
      setSelectedGroupId(null);
      toast.success("Group updated successfully:");
      setSelectedClass("");
      closeCreateGroupModal();
      refetch();
    } catch (error) {
      toast.error("Error updating group");
      console.error("Error updating group:", error);
    } finally {
      setGroupLoading(false); // Stop loading
    }
  };

  const closeScemaModal = () => {
    setIsModalOpen(false);
  };

  const handleExportButtonClick = () => {
    if (selectedGroupName) {
      setShowExportPopup(true);
    }
  };

  const throttle = (func, limit) => {
    let lastFunc;
    let lastRan;
    return function (...args) {
      if (!lastRan) {
        func.apply(this, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(() => {
          if (Date.now() - lastRan >= limit) {
            func.apply(this, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  };

  const handleZoomInGraph = throttle(() => {
    if (cyRef) {
      const newZoom = cyRef.zoom() * 1.2;

      // Calculate the center of the viewport
      const center = {
        x: cyRef.container().clientWidth / 2,
        y: cyRef.container().clientHeight / 2,
      };

      // Zoom to the new level, with the center as the focal point
      cyRef.zoom({
        level: newZoom,
        renderedPosition: center,
      });
    }
  }, 100);

  const handleZoomOutGraph = throttle(() => {
    if (cyRef) {
      const newZoom = cyRef.zoom() / 1.2;

      // Calculate the center of the viewport
      const center = {
        x: cyRef.container().clientWidth / 2,
        y: cyRef.container().clientHeight / 2,
      };

      // Zoom to the new level, with the center as the focal point
      cyRef.zoom({
        level: newZoom,
        renderedPosition: center,
      });
    }
  }, 100);

  const handleResetGraph = () => {
    if (cyRef) {
      cyRef.zoom({ level: -5, position: { x: 0, y: 0 } }).fit();
    }
  };

  const handleSaveSearchClick = () => {
    setShowSaveSearchModal(true);
  };

  const handleInputSaveSearch = async ({ searchName, comment, link }) => {
    if (!searchName.trim()) {
      alert("Please enter a name for the search.");
      return;
    }

    try {
      var rulesForJson = {
        includeClasses: [],
        includeTopics: [],
        includeKeywords: Array.from(filters.includeKeywords),
      };
      const response = await api.post("/save-search", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: searchName,
          comment,
          link,
          rules: rulesForJson,
          tags: tags,
          userId: userId,
        }),
      });

      if (!response.ok) throw new Error("Save search API call failed");

      toast.success("Search saved successfully!");
      setShowSaveSearchModal(false);
    } catch (error) {
      console.error("Error saving search:", error);
      toast.error("Failed to save search. Please try again.");
    }
  };

  const startContinuousZoomIn = () => {
    if (!zoomInInterval.current) {
      zoomInInterval.current = setInterval(handleZoomInGraph, 100); // Adjust interval speed if needed
    }
  };

  const startContinuousZoomOut = () => {
    if (!zoomOutInterval.current) {
      zoomOutInterval.current = setInterval(handleZoomOutGraph, 100);
    }
  };

  const stopContinuousZoom = () => {
    if (zoomInInterval.current) {
      clearInterval(zoomInInterval.current);
      zoomInInterval.current = null;
    }
    if (zoomOutInterval.current) {
      clearInterval(zoomOutInterval.current);
      zoomOutInterval.current = null;
    }
  };

  return (
    <>
      {!isPlaybookLink ? (
        <div className="main-content">
          <div className="header gap-3">
            {/* <div className="search-container">
          <IoIosSearch className="search-icon" />
          <input type="text" placeholder="Search" className="search-input" />
            <IoIosCheckboxOutline className="checks-icon" />
        </div> */}
            <div className="search-container d-flex align-items-center ms-searchbox gap-2">
              <TagsInputSearch
                handleChange={handleChange}
                tags={Array.from(filters.includeKeywords)}
              />
              <button
                className="icon-button delete-saved-search ms-icon-btn ms-icon-btn-md ms-icon-btn-bg ms-icon-save-btn"
                onClick={handleSaveSearchClick}
                title="Save Search"
                disabled={
                  Array.from(filters.includeKeywords).length === 0 ||
                  graphData?.nodes?.length === 0 ||
                  currentRole === "viewer"
                }
              >
                <LuSave className="d-none" />
              </button>
              <div style={{ zIndex: 999 }}>
                <Select
                  options={savedSearches.map((search) => ({
                    value: search.id,
                    label: search.name,
                  }))}
                  isLoading={savedSearchesLoading}
                  isDisabled={savedSearchesError || savedSearchesLoading}
                  value={
                    savedSearches
                      .map((search) => ({
                        value: search.id,
                        label: search.name,
                      }))
                      .find((option) => option.value === selectedSearchId) ||
                    null
                  }
                  onChange={handleSearchSelect}
                  placeholder="Select Saved Search"
                  className="header-select"
                />
              </div>
              <button
                className="icon-button delete-saved-search ms-icon-btn ms-icon-btn-md ms-icon-btn-bg ms-icon-edit-btn"
                onClick={handleOpenEditModal}
                title="Edit Search"
                disabled={currentRole === "viewer" || !selectedSearchId}
              >
                <FaRegEdit className="d-none" />
              </button>
              <button
                className="icon-button delete-saved-search ms-icon-btn ms-icon-btn-md ms-icon-btn-bg ms-icon-delete-btn"
                onClick={handleDeleteSearchClick}
                title="Delete this saved search?"
                disabled={currentRole === "viewer" || !selectedSearchId}
              >
                <MdDelete className="d-none" />
              </button>
              {currentRole !== "viewer" ? (
                <>
                  <Select
                    options={groups.map((group) => ({
                      value: group.id,
                      label: group.name,
                    }))}
                    isLoading={groupsLoading}
                    isDisabled={groupsError || groupsLoading}
                    value={
                      groups
                        .map((group) => ({
                          value: group.id,
                          label: group.name,
                        }))
                        .find((group) => group.value === selectedGroupId) ||
                      null
                    }
                    onChange={handleDropdownChange}
                    placeholder="Select Any Group Design"
                    className="header-select"
                  />
                  <button
                    className="icon-button delete-saved-search ms-icon-btn ms-icon-btn-md ms-icon-btn-bg ms-icon-edit-btn"
                    title="Edit this model?"
                    disabled={selectedGroupId ? false : true}
                    onClick={handleEditGroup}
                  >
                    <FaRegEdit className="d-none" />
                  </button>
                  <button
                    className="icon-button delete-saved-search ms-icon-btn ms-icon-btn-md ms-icon-btn-bg ms-icon-delete-btn"
                    onClick={handleDeleteClick}
                    title="Delete this model?"
                    disabled={selectedGroupId ? false : true}
                  >
                    <MdDelete className="d-none" />
                  </button>
                  <button
                    className="icon-button delete-saved-search ms-icon-btn ms-icon-btn-md ms-icon-btn-bg ms-icon-export-btn"
                    onClick={handleExportButtonClick}
                    title="Export the selected group?"
                    disabled={selectedGroupId ? false : true}
                  >
                    <SiMinutemailer className="d-none" />
                  </button>
                </>
              ) : (
                <div style={{ width: "" }}></div>
              )}
            </div>
            {/* <IoIosCheckboxOutline className="checkboxs-icon" />  Checkbox icon added here */}
            {/* <div className="d-flex gap-2 save-search-box"></div> */}
            {/* Reusing the Dropdown Component for Groups */}
          </div>
          <hr className="divider" />
          <div className="content-sections">
            <div className="left-panel">
              {loading ? (
                <div className="spinner-container">
                  <Spinner animation="border" />
                </div>
              ) : (
                // graphData && (
                <>
                  {/* Graph Pane */}
                  <NodeSchemaViewPane isPlaybookLink={isPlaybookLink} />
                </>
                // )
              )}
            </div>

            <div className="right-panel" style={{ position: "relative" }}>
              {viewType === "Schema" &&
                (graphLoading ? (
                  <div className="spinner-container">
                    <Spinner animation="border" />
                  </div>
                ) : currentRole === "viewer" ? (
                  <div className="alert alert-info">
                    The Schema and Topics listings are available to Editors
                    only. Guidance on using the Mattersmith Platform can be
                    found by browsing the Help topic opposite.
                    {/* {this.renderCloseButton()} */}
                  </div>
                ) : (
                  <>
                    <div className="zoom-controls">
                      <div className="zoom-box" onClick={handleResetGraph}>
                        <IoResize className="zoom-icon-reset" />
                      </div>
                      <div
                        className="zoom-box"
                        onMouseDown={startContinuousZoomIn}
                        onMouseUp={stopContinuousZoom}
                        onMouseLeave={stopContinuousZoom}
                        onClick={handleZoomInGraph}
                      >
                        <FiPlus className="zoom-icon" />
                      </div>
                      <div
                        className="zoom-box"
                        onMouseDown={startContinuousZoomOut}
                        onMouseUp={stopContinuousZoom}
                        onMouseLeave={stopContinuousZoom}
                        onClick={handleZoomOutGraph}
                      >
                        <FiMinus className="zoom-icon" />
                      </div>
                    </div>
                    <CytoscapeGraph
                      data={graphSchemaData}
                      onCreateGroup={handleCreateGroup}
                      onCreateChild={handleCreateChild}
                      onNode={handleNodeClick}
                      onSchema={handleSchemaClick}
                      onCyRef={handleCyRef}
                      refetch={refetchGraphData}
                    />
                    {showCreateChildModal && (
                      <CreateChildModal
                        show={showCreateChildModal}
                        handleClose={closeCreateChildModal}
                        handleCreate={createChildNode}
                      />
                    )}
                    {showNodeModal && (
                      <CreateNode
                        show={showNodeModal}
                        handleClose={closeNodeModal}
                        initialNodeData={selectedNodeData.nodeData}
                        cy={cyRef}
                      />
                    )}
                    {isModalOpen && (
                      <SchemaInfo
                        show={isModalOpen}
                        handleClose={closeScemaModal}
                        schemaData={selectedSchemaData}
                        cy={cyRef}
                      />
                    )}
                  </>
                ))}

              {showCreateGroupModal && (
                <CreateGroupModal
                  mode={isEditGroupMode ? "edit" : "save"}
                  show={showCreateGroupModal}
                  handleClose={closeCreateGroupModal}
                  schemaData={schemaGraphData}
                  classOptions={classOptions}
                  secondDropdownOptions={secondDropdownOptions}
                  selectedClass={selectedClass}
                  onClassChange={handleClassChange}
                  setSelectedClass={setSelectedClass}
                  selectedRelation={selectedRelation}
                  onRelationChange={handleRelationChange}
                  handleGroupSave={handleGroupSave}
                  handleGroupEdit={handleGroupEdit}
                  setShowCreateGroupModal={setShowCreateGroupModal}
                  groupData={
                    isEditGroupMode
                      ? groups.find(
                          (group) => group.id === parseInt(selectedGroupId, 10)
                        )
                      : null
                  }
                  groupLoading={groupLoading}
                  errors={errors}
                />
              )}
              {viewType === "Topics" &&
                (topicGraphLoading ? (
                  <div className="spinner-container">
                    <Spinner animation="border" />
                  </div>
                ) : currentRole === "viewer" ? (
                  <div className="alert alert-info">
                    The Schema and Topics listings are available to Editors
                    only. Guidance on using the Mattersmith Platform can be
                    found by browsing the Help topic opposite.
                    {/* {this.renderCloseButton()} */}
                  </div>
                ) : (
                  <TopicGraph
                    data={topicGraphData}
                    cyRef={cyRef}
                    onCyRef={handleCyRef}
                  />
                ))}

              {viewType === "Playbook" && (
                <div className="alert alert-info">
                  <strong>Cannot display Playbook:</strong> No Playbook opened,
                  or the opened Playbook has no PlaybookRules. Open a Playbook
                  and it will appear here.
                  {/* {this.renderCloseButton()} */}
                </div>
              )}
            </div>
          </div>
          {/* Using the reusable ModalComponent */}
          <ModalComponent
            show={showPopup}
            handleClose={handlePopupClose}
            title="Confirm"
            bodyText={`Do you want to create a model with '${selectedGroupName}'?`}
            primaryAction={handleCreateModel}
            primaryLabel="Create"
            modelLoading={modelLoading}
          />
          <ExportModal
            show={showExportPopup}
            setShowExportPopup={setShowExportPopup}
            selectedGroupName={selectedGroupName}
          />
          <DeleteGroupModal
            show={showDeletePopup}
            handleClose={() => setShowDeletePopup(false)}
            groupName={
              deleteType === "customSearch"
                ? selectedSearchId
                : selectedGroupName
            }
            handleDelete={
              deleteType === "customSearch"
                ? handleDeleteCustomSearch
                : handleDeleteGroup
            }
            deleteType={deleteType}
          />
          <SaveSearchModal
            show={showSaveSearchModal}
            onHide={() => setShowSaveSearchModal(false)}
            searchName={searchName}
            setSearchName={setSearchName}
            onSave={handleSaveSearch}
            saveSearchLoading={saveSearchLoading}
          />
          <SearchComponent
            show={showSearchModal}
            handleClose={handleCloseSearchModal}
            onSave={handleSaveSearch}
            mode={isEditMode ? "edit" : "save"}
            isSaved={isSaved}
            searchData={
              isEditMode
                ? savedSearches.find(
                    (search) => search.id === Number(selectedSearchId)
                  )
                : null
            }
          />
        </div>
      ) : (
        graphData && (
          <>
            {/* Graph Pane */}
            <NodeSchemaViewPane isPlaybookLink={isPlaybookLink} />
          </>
        )
      )}

      {isPlaybookLink && <Loader />}
    </>
  );
};

export default MainContent;
